import React, {Component} from 'react';
import classes from '../../GeneralFormComponent/GeneralFormComponent.module.scss';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/es/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import Directives from '../../../Directives/Directives';
import {IDropdownField} from '../formFields';
import MenuItem from '@material-ui/core/MenuItem';

interface IProps extends IDropdownField {
    errors: any;
    touched: any;

    onChange(name: string): any;
}

class DropdownField extends Component<IProps> {

    getValue = (selectedKey: any) => {
        return selectedKey || '';
    };

    render() {
        return (
            <FormControl className={classes.filed}>
                <TextField
                    select
                    name={this.props.name}
                    label={this.props.label}
                    className={classes.textField}
                    value={this.getValue(this.props.value)}
                    style={{fontSize: '18px'}}
                    onChange={this.props.onChange(this.props.name)}
                    SelectProps={{
                        MenuProps: {
                            className: classes.menu,
                        },
                    }}
                    variant='outlined'
                >
                    {this.props.selectList.map((name: any, index: number) => (
                        <MenuItem key={name[this.props.selectListKey]} value={name[this.props.selectListKey]}>
                            {name[this.props.selectListValue]}
                        </MenuItem>
                    ))}
                </TextField>
                <Directives dIf={this.props.errors[this.props.name] && this.props.touched[this.props.name]}>
                    <FormHelperText className={classes.error}>{this.props.errors[this.props.name]}</FormHelperText>
                </Directives>
            </FormControl>
        );
    }
}

export default DropdownField;
